export var DrivingDistance;
(function (DrivingDistance) {
    DrivingDistance["Between0And1000"] = "Between0And1000";
    DrivingDistance["Between1000And1500"] = "Between1000And1500";
    DrivingDistance["Between1500And2000"] = "Between1500And2000";
    DrivingDistance["Between2000And2500"] = "Between2000And2500";
    DrivingDistance["Over2500"] = "Over2500";
})(DrivingDistance || (DrivingDistance = {}));
